export function* vehicleStatusesSaga() {
}